(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mayhew-drop-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mms-countdown]').forEach(function(countdown){
    var target=Date.parse(countdown.dataset.launchAt);
    var days=countdown.querySelector('[data-countdown-days]');
    var hours=countdown.querySelector('[data-countdown-hours]');
    var minutes=countdown.querySelector('[data-countdown-minutes]');
    var seconds=countdown.querySelector('[data-countdown-seconds]');
    var state=countdown.querySelector('[data-countdown-state]');
    var timer;
    var pad=function(value){return String(value).padStart(2,'0')};
    var render=function(){
      var distance=Math.max(0,target-Date.now());
      days.textContent=pad(Math.floor(distance/86400000));
      hours.textContent=pad(Math.floor(distance%86400000/3600000));
      minutes.textContent=pad(Math.floor(distance%3600000/60000));
      seconds.textContent=pad(Math.floor(distance%60000/1000));
      if(distance===0){
        countdown.classList.add('is-expired');
        state.textContent=countdown.dataset.expiredMessage;
        if(timer){window.clearInterval(timer)}
      }
    };
    render();
    if(!countdown.classList.contains('is-expired')){timer=window.setInterval(render,1000)}
  });

  } catch(e) { console.error(e); }
})();
})();
